import { debounce } from '@mui/material';
import { useState, useEffect } from 'react';

const useScreenSize = () => {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [screenHeight, setScreenHeight] = useState(window.innerHeight);

  const handleResize = debounce(() => {
    setScreenWidth(window.innerWidth);
    setScreenHeight(window.innerHeight);
  }, 200);

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return {
    screenWidth,
    screenHeight,
    isResponsiveCustom: (width: number, isMoreThan: boolean) => {
      if(isMoreThan) return screenWidth > width;
      return screenWidth <= width;
    } ,
    isResponsiveDesktop: () => screenWidth >= 992,
    isResponsiveTablet: () => screenWidth >= 600 && screenWidth < 992,
    isResponsiveMobile: () => screenWidth < 600,
  };
};

export default useScreenSize;
